export default __webpack_public_path__ + "static/media/player.55b169b5.svg";